import * as types from 'modules/dealers/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 *  @typedef {string|number|boolean} ValueType
 *  @typedef {{
 *    extensions?: Array<import('modules/global/typing/enums/extensions.enum').ExtensionEnum>;
 *    features?: Array<import('modules/global/typing/enums/features.enum').FeaturesEnum>;
 *    text ?: string;
 *    groupIds ?: Array<string>;
 *    countries ?: Array<string>;
 * }} State
 */
/** @type {State} */
const initialState = {};

/**
 * @param {State} state
 * @param {import('modules/dealers/types').SetDealersModalFilterAction} action
 * @return {State}
 */
const setFilters = (state, { payload: filters }) => ({
  ...state,
  ...filters,
});

/**
 * @param {State} state
 * @param {import('modules/dealers/types').RemoveDealersModalFilterAction} action
 * @return {State}
 */
const removeFilter = (state, { payload }) => {
  const { field, value } = payload;
  const { [field]: root = [], ...rest } = state;

  let newValues = null;
  const isArray = Array.isArray(root);
  if (isArray) {
    newValues = root.filter(val => value !== val);
  }

  const isNotEmpty = (isArray && newValues.length > 0) || (!isArray && newValues);

  if (isNotEmpty) {
    return {
      ...rest,
      [field]: newValues,
    };
  }
  return rest;
};

/**
 * @param {State} state
 * @param {import('modules/dealers/types').OpenModalSelectorAction} action
 * @return {State}
 */
const onOpenModal = (state, { payload, ...restAction }) =>
  setFilters(state, { ...restAction, payload: { extensions: [], features: [], ...payload } });

/**
 * @param {State} state
 * @returns {State}
 */
const clearFilters = ({ extensions, features }) => ({ ...initialState, extensions, features });

export default createReducer(initialState, {
  [types.OPEN_SELECT_DEALER_MODAL]: onOpenModal,
  [types.SET_MODAL_DEALERS_FILTER]: setFilters,
  [types.CLEAR_MODAL_DEALERS_FILTER]: clearFilters,
  [types.REMOVE_MODAL_DEALERS_FILTER]: removeFilter,
});
